export default {
    home: {
      sectionOneParticlesVisible: false,
      sectionTwoParticlesVisible: false
    },
    header: {
      appLogoAnimating: false
    },
    about: {
        isVisible: false,
        separatorBarExpanded: false
    },
    services: {
        isVisible: false,
        webDevelopmentVisible: false,
        userExperienceVisible: false,
        frontEndVisible: false,
        strategyVisible: false,
        sectionThreeSeparatorExpanded: false
    },
    readyToStart: {
        isVisible: false
    },
    slideUpMenu: {
      open: false
    },
    servicesPart2: {
      separatorBarExpanded: false
    },
    overlay: {
        isVisible: false
    },
    technologies: {
       isVisible: false
    }
}


// WEBPACK FOOTER //
// ./src/reducers/initial-states/sections.js